import React from 'react';
import RentalTool from '../../../components/tools/rental/RentalTool';

export default function RentalPage() {
    return (
        <div style={{ height: '100%', overflow: 'auto' }}>
            <RentalTool />
        </div>
    );
}
